exports.require = function() {
  var fs = require("fs");
  if (process.versions['electron']) {
	  try {
		  fs = require("original-fs")
	  } catch (e) {}
  }
  return fs
};



//////////////////
// WEBPACK FOOTER
// ./~/adm-zip/util/fileSystem.js
// module id = 180
// module chunks = 0